_ = require 'underscore'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
{ googleMapsApiKey } = require '@trello/config'
LOCATION_CLUSTER_SVG = require('resources/images/location-cluster.svg')
MARKER_ICON_URL = require('resources/images/location-marker.png')
MARKER_STYLE = "icon:#{encodeURIComponent(MARKER_ICON_URL)}"

{ markerClustererLoader } = require 'app/scripts/lib/marker-clusterer-loader'

# The Google Static Maps API needs to hit the image URL.
# They can't hit out localhost so let's just make it blue.
if __DEV__
  MARKER_STYLE = 'color:blue'

class GoogleMapsApi
  load: ->
    @_loadGoogleMapsApiPromise ?= Promise.try =>
      if window.google? && window.google.maps?
        return
      Util.loadScript("https://maps.googleapis.com/maps/api/js?key=#{googleMapsApiKey}&libraries=places")
    .return()

    @_loadMarkerClustererPromise ?= markerClustererLoader()
      .then((library) =>
        @MarkerClusterer = library

        # Overide the cluster marker style because MarkerClusterer
        # builds the `url` dynamically with a relative path you pass
        # in a constructor option. This won't work for us because of
        # how we serve our static resources.
        @MarkerClusterer.prototype.setupStyles_ = ->
          if @styles_.length > 0
            return

          _.times @imageSizes_.length, =>
            @styles_.push({
              url: LOCATION_CLUSTER_SVG
              height: 40
              width: 40
            })
      )

    return Promise.all([@_loadGoogleMapsApiPromise, @_loadMarkerClustererPromise])

  createMap: (containerId, options = {}) ->
    @load().then =>
      new window.google.maps.Map(document.getElementById(containerId), options)

  createLatLng: (lat, lng) ->
    new window.google.maps.LatLng(lat, lng)

  createLatLngBounds: ->
    new window.google.maps.LatLngBounds()

  createMarker: (options = {}) ->
    new window.google.maps.Marker(options)

  createMarkerClusterer: (map, markers, opts = {}) ->
    if !@MarkerClusterer
      throw new Error('MarkerClusterer is not yet loaded. You need to await GoogleMapsApi.load() first')
    new @MarkerClusterer(map, markers, opts)

  createInfoWindow: (options = {}) ->
    new window.google.maps.InfoWindow(options)

  getPlacesService: ->
    @placesService ?= new window.google.maps.places.PlacesService(document.createElement('div'))

  getAutocompleteService: ->
    @autocompleteService ?= new window.google.maps.places.AutocompleteService()

  createPlacesSessionToken: ->
    new window.google.maps.places.AutocompleteSessionToken()

  autocomplete: ({ input, sessionToken } = {})  ->
    @load().then =>
      new Promise (resolve, reject) =>
        @getAutocompleteService().getPlacePredictions({
          input,
          sessionToken
        }, (predictions, status) =>
          if status != window.google.maps.places.PlacesServiceStatus.OK
            return reject(status)

          return resolve(predictions)
        )

  getPlaceDetails: ({ placeId, sessionToken, fields }) ->
    @load().then =>
      new Promise (resolve, reject) =>
        @getPlacesService().getDetails({
          placeId,
          sessionToken,
          fields
        }, (place, status) =>
          if status != window.google.maps.places.PlacesServiceStatus.OK
            return reject(status)
          return resolve(place)
        )

  getStaticMap: ({ zoom, width, height, scale, markers } = {}) ->
    url = "https://maps.googleapis.com/maps/api/staticmap?key=#{googleMapsApiKey}"

    url += "&zoom=#{zoom}" if zoom?
    url += "&size=#{width}x#{height}" if width? && height?
    url += "&scale=#{scale}" if scale?

    if markers?
      url += "&markers=#{MARKER_STYLE}%7C"
      _.each markers, ({ latitude, longitude }, index) ->
        url += "#{encodeURIComponent(latitude)}%2C#{encodeURIComponent(longitude)}"
        url += "%7C" if index != markers.length - 1

    return url

  getUrl: (lat, lng) ->
    "https://www.google.com/maps/search/?api=1&query=#{encodeURIComponent(lat)}%2C#{encodeURIComponent(lng)}"

module.exports = new GoogleMapsApi()
